// @flow
import React, { type ElementRef } from 'react';
import InterestMasonry from 'app/common/react/components/growth/activation/InterestMasonry/InterestMasonry';
import NuxInterest from 'app/common/react/components/growth/activation/NuxInterest/NuxInterest';
import storage from 'app/common/lib/Storage';
import { type InterestObj } from 'app/common/react/components/growth/activation/NuxConst/NuxConst';

type OwnProps = {|
  gridContainerRef: ElementRef<any>,
  handleBottomScroll: (isBottom: boolean) => void,
  handleInterestClickFn: (InterestObj) => () => void,
  interests: Array<InterestObj>,
  showTableOfContents?: boolean,
  interestFlipMessages: { [key: string]: string },
  interestsToFlip: Set<string>,
|};

type InterestProps = {|
  itemIdx: number,
  data: InterestObj,
|};

const NuxPickerInterests = (props: OwnProps) => {
  const { interests, handleInterestClickFn, interestFlipMessages, interestsToFlip } = props;

  // This should really be in its own file, but Masonry only passes itemIdx and data.
  // Therefore, we must give it access to the props of this file.
  // Ask @kdavison (Growth - NUX) for more context.
  const Interest = ({ itemIdx: index, data: interest }: InterestProps) => {
    const interestProps = {
      clickHandler: handleInterestClickFn(interest),
      interest,
      key: interest.id,
      isSelected: interest.is_followed,
      flipText: interestFlipMessages[interest.id] || '',
      shouldFlip: interestsToFlip.has(interest.id),
    };

    if (interests.length > 0) {
      storage.localStorage.setItem(
        PCONST.LOCALSTORAGE_SIGNUP_INTERESTS_PICKER_START_TIME,
        Date.now(),
      );
    }

    // $FlowFixMe: new errors found from flow 0.96 upgrade
    return <NuxInterest {...interestProps} />;
  };

  // $FlowFixMe: new errors found from flow 0.96 upgrade
  return <InterestMasonry {...props} InterestComponentToRender={Interest} />;
};

export default NuxPickerInterests;
